import type { RouteRecordRaw } from 'vue-router'

export const communicationRoutes: RouteRecordRaw[] = [
  {
    path: '/communication',
    name: 'communication',
    component: () => import('../components/CommunicationLayout.vue'),
    redirect: { name: 'communicationDashboard' },
    meta: {
      title: 'routes.communication',
      requiresAuth: true,
      breadcrumb: 'Communication'
    },
    children: [
      {
        path: 'dashboard',
        name: 'communicationDashboard',
        component: () => import('../dashboard/components/Dashboard.vue'),
        meta: {
          title: 'routes.communicationDashboard',
          requiresAuth: true,
          breadcrumb: 'Dashboard'
        }
      },
      {
        path: 'manage',
        name: 'communicationManage',
        component: () => import('../dashboard/components/Manage.vue'),
        meta: {
          title: 'routes.communicationManage',
          requiresAuth: true,
          breadcrumb: 'Manage'
        }
      },
      {
        path: 'triggers',
        name: 'communicationTriggers',
        component: () => import('../triggers/components/TriggersTable.vue'),
        meta: {
          title: 'routes.communicationTriggers',
          requiresAuth: true,
          breadcrumb: 'Triggers'
        }
      },
      {
        path: 'triggers/details',
        name: 'communicationTriggerDetails',
        component: () => import('../triggers/components/TriggersDetails.vue'),
        meta: {
          title: 'routes.communicationTriggerDetails',
          requiresAuth: true,
          breadcrumb: 'Trigger Details'
        }
      },
      {
        path: 'wizard/patient-broadcast',
        name: 'communicationWizardPatientBroadcast',
        component: () => import('../wizard/components/WizardPatientBroadcast.vue'),
        meta: {
          title: 'routes.communicationWizardPatientBroadcast',
          requiresAuth: true,
          breadcrumb: 'Patient Broadcast Wizard'
        }
      },
      {
        path: 'pathways',
        name: 'communicationPathways',
        component: () => import('../templates/components/CommunicationPathways.vue'),
        meta: {
          title: 'routes.communicationPathways',
          requiresAuth: true,
          breadcrumb: 'Communication Pathways'
        }
      },
      {
        path: 'engagement',
        name: 'communicationNewUserEngagement',
        component: () => import('../templates/components/NewUserEngagement.vue'),
        meta: {
          title: 'routes.communicationNewUserEngagement',
          requiresAuth: true,
          breadcrumb: 'User Engagement'
        }
      },
      {
        path: 'templates',
        name: 'communicationTemplates',
        component: () => import('../templates/components/CommunicationTemplate.vue'),
        meta: {
          title: 'routes.communicationTemplates',
          requiresAuth: true,
          breadcrumb: 'Templates'
        }
      },
      {
        path: 'templates/tabs',
        name: 'communicationTemplateTabs',
        component: () => import('../templates/components/TemplateTabs.vue'),
        meta: {
          title: 'routes.communicationTemplateTabs',
          requiresAuth: true,
          breadcrumb: 'Template Tabs'
        }
      },
      {
        path: 'templates/sms-tabs',
        name: 'communicationSmsTemplateTabs',
        component: () => import('../templates/components/SmsTemplateTabs.vue'),
        meta: {
          title: 'routes.communicationSmsTemplateTabs',
          requiresAuth: true,
          breadcrumb: 'SMS Template Tabs'
        }
      },
      {
        path: 'broadcast',
        name: 'communicationBroadcastList',
        component: () => import('../broadcast/components/BroadcastList.vue'),
        meta: {
          title: 'routes.communicationBroadcastList',
          requiresAuth: true,
          breadcrumb: 'Broadcast'
        }
      },
      {
        path: 'broadcast/creation',
        name: 'communicationBroadcastCreation',
        component: () => import('../broadcast/components/BroadcastCreation.vue'),
        meta: {
          title: 'routes.communicationBroadcastCreation',
          requiresAuth: true,
          breadcrumb: 'Broadcast Creation'
        }
      },
      {
        path: 'broadcast/details',
        name: 'communicationBroadcastDetails',
        component: () => import('../broadcast/components/BroadcastDetails.vue'),
        meta: {
          title: 'routes.communicationBroadcastDetails',
          requiresAuth: true,
          breadcrumb: 'Broadcast Details'
        }
      },
      {
        path: 'broadcast/multi-stage-engagement',
        name: 'communicationMultiStageEngagement',
        component: () => import('../broadcast/components/MultiStageCommunicationUserEngagement.vue'),
        meta: {
          title: 'routes.communicationMultiStageEngagement',
          requiresAuth: true,
          breadcrumb: 'Multi-Stage Engagement'
        }
      },
      {
        path: 'campaigns',
        name: 'communicationCampaigns',
        component: () => import('../campaign/components/CampaignTableview.vue'),
        meta: {
          title: 'routes.communicationCampaigns',
          requiresAuth: true,
          breadcrumb: 'Campaigns'
        }
      },
      {
        path: 'campaigns/creation',
        name: 'communicationCampaignCreation',
        component: () => import('../campaign/components/CampaignCreation.vue'),
        meta: {
          title: 'routes.communicationCampaignCreation',
          requiresAuth: true,
          breadcrumb: 'Campaign Creation'
        }
      },
      {
        path: 'campaigns/details',
        name: 'communicationCampaignDetails',
        component: () => import('../campaign/components/CampaignDetails.vue'),
        meta: {
          title: 'routes.communicationCampaignDetails',
          requiresAuth: true,
          breadcrumb: 'Campaign Details'
        }
      }
    ]
  }
]
